import {SmallTexts} from "../enums/small-texts";
import {subtitles, titles} from "./texts-common-sections";
import {Documents, DocumentsIds} from "./documents";

export const urlImages = "/assets/images/modules/section_2/";
const urlIcons = "/assets/images/icons/";

export const Section2 = {
  ExplanationTexts: {
    title_expl01: subtitles.subtitleLeSaviezVous,
    text_expl01: "<span class='d-block'>En moyenne à l’officine</span>" +
      "<span class='my-2 d-block fw-bold color-green'>4 dispensations de pansements/jour<sup>*</sup></span>" +
      "pour la prise en charge des plaies chroniques.<sup>1</sup>",
    image_expl01: urlImages + "02sec01e_img.png",
    asterisks_expl01: ["Basé sur la réponse de 28 pharmaciens d’officine."],
    annexes_expl01: [
      "<span class='d-block'>Vous et votre équipe jouez un <span class='fw-bold'>rôle central<br" +
      " class='d-none d-lg-block'/> dans" +
      " l’accompagnement</span> de ces patients à l’officine.</span>",
    ],
    title_expl02: titles.titleComprendreLesPlaies,
    text_expl02: "Une plaie est une <span class='fw-bold'>lésion de la peau</span> représentée par une <span class='fw-bold'>rupture de la continuité des tissus et une effraction de la barrière cutanée</span> nécessitant un processus dynamique complexe  pour être réparée ou cicatrisée.<sup>1</sup>",
    image_expl02: urlImages + "02sec02e_img.jpg",
    title_expl03: titles.titleComprendreLesPlaies,
    text_expl03: "On distingue <span class='fw-bold'>2 grands types</span> de plaies<sup>1,2</sup>&nbsp;:",
    list_title_expl03: "Les plaies",
    text_flex_columns_expl03: [
      {
        group: 'aiguës',
        title: '< 4 semaines',
        content: 'Plaies d’apparition soudaine et de courte durée qui cicatriseront le plus souvent spontanément'
      },
      {
        group: 'chroniques',
        title: '≥ 4 à 6 semaines',
        content: 'Plaies dont le délai de cicatrisation est allongé en raison d’une pathologie sous-jacente (diabète, insuffisance veineuse ou artérielle, etc.)'
      }
    ],
    //picto_annexe_expl03: urlIcons + "danger.svg",
    annexes_expl03: [
      "<span class='px-0 px-lg-4 d-flex flex-column flex-lg-row align-items-center justify-content-center'><span><img width='50' src='"
      + urlIcons + "L&R_Picto_Attention.png" +
      "' class='mb-3 mb-lg-0'></span><span class='text-start ms-0 ms-lg-3'>Une plaie aiguë peut devenir chronique<br" +
      " class='d-none d-lg-block'/>" + " lorsque la cicatrisation est perturbée.</span></span>",
    ],
    title_expl04: titles.titleComprendreLesPlaies,
    text_expl04: "Voici quelques <span class='fw-bold'>exemples de plaies</span>.</br>Découvrez l’aspect de chaque" +
      " plaie en cliquant sur l’étiquette <br class='d-none d-xl-block'/>(liste non exhaustive).",
    list_title_expl04: "Plaies",
    list_buttons_expl04: [
      {
        group: "aiguës",
        title: "Brûlures",
        content: [
          {
            image: urlImages + "02secPA_bru_01.jpg"
          },
          {
            image: urlImages + "02secPA_bru_02.jpg"
          },
          {
            image: urlImages + "02secPA_bru_03.jpg"
          }
        ]
      },
      {
        group: "aiguës",
        title: "Plaies traumatiques",
        content: [
          {
            text: "<span class='d-block text-center fw-bold'>Dermabrasions</span>",
            image: urlImages + "02secPA_tra_01.jpg"
          },
          {
            text: "<span class='d-block text-center fw-bold'>Dermabrasions</span>",
            image: urlImages + "02secPA_tra_02.jpg"
          },
          {
            text: "<span class='d-block text-center fw-bold'>Déchirures cutanées</span>",
            image: urlImages + "02secPA_tra_03.jpg"
          }
        ]
      },
      {
        group: "aiguës",
        title: "Plaies chirurgicales",
        content: [
          {
            text: "<span class='d-block text-center fw-bold'>Sutures chirurgicales</span>",
            image: urlImages + "02secPA_chi_01.jpg"
          },
          {
            text: "<span class='d-block text-center fw-bold'>Agrafes chirurgicales</span>",
            image: urlImages + "02secPA_chi_02.jpg"
          },
          {
            text: "<span class='d-block text-center fw-bold'>Chirurgies mini-invasives</span>",
            image: urlImages + "02secPA_chi_03.jpg"
          }
        ]
      },
      {
        group: "chroniques",
        title: "Ulcères de jambes",
        content: [
          {
            image: urlImages + "02secPA_uljamb_01.jpg"
          },
          {
            image: urlImages + "02secPA_uljamb_02.jpg"
          }
        ]
      },
      {
        group: "chroniques",
        title: "Escarres",
        content: [
          {
            image: urlImages + "02secPA_esc_01.jpg"
          },
          {
            image: urlImages + "02secPA_esc_02.jpg"
          }
        ]
      },
      {
        group: "chroniques",
        title: "Plaies du pied diabétique",
        content: [
          {
            image: urlImages + "02secPA_piediab_01.jpg"
          },
          {
            image: urlImages + "02secPA_piediab_02.jpg"
          }
        ]
      }
    ],
    title_expl05: titles.titleLaCicatrisation,
    image_expl05: urlIcons + "info_i.svg",
    text_expl05: "Le processus de cicatrisation est un <span class='fw-bold'>processus naturel" +
      " multifactoriel</span> pouvant se définir comme la réponse élaborée par la peau à toute atteinte de son intégrité.<sup>1</sup>",
    title_expl06: titles.titleLaCicatrisation,
    text_expl06: "Le déroulement du processus de la cicatrisation met en jeu des <span class='fw-bold'>facteurs individuels</span><sup>1,2</sup>&nbsp;:",
    list_buttons_expl06: [
      {
        group: "",
        title: "L’âge",
        content: [
          {
            text: "<span class='fw-bold color-red'>L'âge</span> fait partie des facteurs ayant de l'influence sur" +
              " la capacité de la peau à se régénérer. <span class='fw-bold'>Les enfants et les sujets d'âge" +
              " intermédiaire bénéficient en principe d'une peau qui cicatrise mieux que les sujets" +
              " âgés</span>.<sup>1-3</sup>",
            small_texts: {
              1: SmallTexts.Amici,
              2: SmallTexts.Chuv,
              3: SmallTexts.Carrera
            }
          }
        ]
      },
      {
        group: "",
        title: "La génétique",
        content: [
          {
            text: "La réponse inflammatoire est <span class='color-red fw-bold'>génétiquement déterminée</span> et" +
              " <span class='fw-bold'>inégale d'un individu à l'autre</span>.<br/>Certaines <span" +
              " class='fw-bold'>origines ethniques</span> sont aussi plus exposées que d'autres au risque" +
              " d'hyperpigmentation post-inflammatoire et de dystrophie cicatricielle.<sup>1</sup>",
            small_texts: {
              1: SmallTexts.Amici,
            }
          }
        ]
      },
      {
        group: "",
        title: "Les comorbidités",
        content: [
          {
            text: "Une <span class='fw-bold'>dénutrition importante</span> ou la présence <span" +
              " class='fw-bold'>d'une ou plusieurs <span class='color-red'>comorbidités</span></span> (maladies" +
              " chroniques impliquant le système cardiovasculaire et affectant la vascularisation tissulaire et son" +
              " oxygénation, diabète, insuffisance rénale…) sont des facteurs néfastes au bon déroulement de la" +
              " cicatrisation.<sup>1,2</sup>",
            small_texts: {
              1: SmallTexts.Chuv,
              2: SmallTexts.Carrera
            }
          }
        ]
      },
      {
        group: "",
        title: "Les traitements",
        content: [
          {
            text: "La prise de <span class='fw-bold color-red'>certains médicaments</span>, notamment <span" +
              " class='fw-bold'>immunosuppresseurs</span>, peut perturber la réponse inflammatoire du processus de" +
              " cicatrisation.<sup>1-3</sup>",
            small_texts: {
              1: SmallTexts.Amici,
              2: SmallTexts.Chuv,
              3: SmallTexts.Carrera
            }
          }
        ]
      },
      {
        group: "",
        title: "Le système immunitaire",
        content: [
          {
            text: "Qu'il soit inné ou acquis, <span class='fw-bold'>un <span class='color-red'>déficit" +
              " immunitaire</span> est un facteur néfaste au bon déroulement du processus de cicatrisation</span>.<sup>1,2</sup>",
            small_texts: {
              1: SmallTexts.Chuv,
              2: SmallTexts.Carrera
            }
          }
        ]
      }
    ],
    annexes_expl06: [
      "<span class='mx-0 mx-lg-3 d-inline-block p-4 bg-green color-white rounded-5'>Ils déterminent un mode de" +
      " cicatrisation particulier <br class='d-none d-xl-block'/>définissant un <span class='fw-bold'>ʺaléa" +
      " cicatriciel individuel multifactorielʺ</span>.</span>"
    ],
    title_expl07: titles.titleProcessusDeCicatrisation,
    text_expl07: "<span class='text-start d-block'>Durant les 3 phases de la cicatrisation, nous distinguons " +
      "<span class='fw-bold'>4 étapes</span>," +
      " identifiables par <span class='fw-bold'>l’aspect</span> et <span class='fw-bold'>la couleur</span> de la plaie.<sup>1,2</sup></span>",
    text_flex_columns_expl07: [
      {
        group: "Phase d’élimination des déchets",
        image: urlImages + "02secDET_q_resp.png",
        content: "<span class='d-block fw-bold color-red text-uppercase mb-2'>Étape 1</span>" +
          "<span class='d-block'>Tissu nécrotique = plaie de <span class='custom-badge bg-black'>couleur" +
          " noire</span> et souvent sèche</span>" +
          "<span class='d-block fw-bold color-red text-uppercase mt-3 mb-2'>Étape 2</span>" +
          "<span class='d-block'>Tissu fibrineux = plaie de <span class='custom-badge bg-yellow'>couleur" +
          " jaune</span> qui peut être sèche ou humide</span>"
      },
      {
        group: "Phase de reconstruction des tissus conjonctifs",
        image: urlImages + "02secGRA_q_resp.png",
        content: "<span class='d-block fw-bold color-red text-uppercase mb-2'>Étape 3</span>" +
          "<span class='d-block'>Tissu de granulation = plaie de <span class='custom-badge bg-red'>couleur" +
          " rouge</span> ressemblant à une framboise</span>"
      },
      {
        group: "Phase de reconstruction des cellules épithéliales",
        image: urlImages + "02secEPI_q_resp.png",
        content: "<span class='d-block fw-bold color-red text-uppercase mb-2'>Étape 4</span>" +
          "<span class='d-block'>Tissu d’épithélialisation = peau de <span class='custom-badge bg-rose'>couleur" +
          " rose</span> très fine</span>"
      }
    ],
    title_expl08: titles.titleProcessusDeCicatrisation,
    image_expl08: urlImages + "02sec08e_img.jpg",
    text_expl08: "<span class='fw-bold'>Voici les 4 étapes de la cicatrisation</span> en" +
      " image<sup>1</sup></span>&nbsp;:",
    list_buttons_expl08: [
      {
        content: [
          {
            text: "<span class='circle bg-black me-3'></span>La nécrose"
          }
        ],
        position: {
          top: "33%",
          left: "33%"
        }
      },
      {
        content: [
          {
            text: "<span class='circle bg-red me-3'></span>Le bourgeonnement"
          }
        ],
        position: {
          top: "25%",
          left: "50%"
        }
      },
      {
        content: [
          {
            text: "<span class='circle bg-yellow me-3'></span>La fibrine"
          }
        ],
        position: {
          top: "35%",
          left: "62%"
        }
      },
      {
        content: [
          {
            text: "<span class='circle bg-rose me-3'></span>L’épithélialisation"
          }
        ],
        position: {
          top: "60%",
          left: "81%"
        }
      },
    ],
    annexes_expl08: [
      "Le lit de la plaie peut présenter plusieurs couleurs."
    ],
    title_expl09: titles.titleCicatrisationExudat,
    text_expl09: "<span class='d-block'>La présence d’exsudat est un aspect important dans la gestion d’une plaie." +
      " L’exsudat est un <span class='fw-bold'>liquide organique tantôt séreux, tantôt muqueux, riche en" +
      " protéines</span> et qui <span class='fw-bold'>s’écoule au niveau de la surface infectée ou inflammée" +
      " d’un tissu</span>.<sup>1</sup></span>" +
      "<span class='d-block mt-3'>Il provient de l’ensemble des éléments moléculaires et" +
      " cellulaires qui <span class='fw-bold'>s'écoulent au niveau de la surface de la" +
      " plaie</span>.<sup>2</sup></span>" +
      "<img class='d-block mt-3' src='" + urlImages + "02sec09e_img.png' />",
    title_expl10: titles.titleCicatrisationExudat,
    text_expl10: "<span class='text-start d-block'>La présence d’exsudat dans la plaie présente à la fois des <span" +
      " class='fw-bold'>aspects positifs et négatifs</span>.<sup>1,2</sup></span>",
    text_flex_columns_expl10: [
      {
        title: "<span class='color-green'>Les aspects positifs de l’exsudat</span>",
        content: "<ul class='m-0 text-start custom-icon plus small'>" +
          "<li>Maintient le milieu humide propice à la cicatrisation</li>" +
          "<li>Favorise la migration des kératinocytes</li>" +
          "<li>Diminue l’inflammation du derme</li>" +
          "<li>Favorise la biosynthèse du collagène</li>" +
          "</ul>"
      },
      {
        title: "<span class='color-red'>L’aspect négatif de l’exsudat</span>",
        content: "<ul class='m-0 text-start custom-icon minus small'>" +
          "<li>Une plaie trop humide entraîne un risque de macération de la plaie et de la peau" +
          " périlésionnelle</li>" +
          "</ul>"
      }
    ],
    title_expl11: titles.titleCicatrisationExudat,
    text_expl11: "Une plaie qui évolue de façon optimale est une plaie dont le volume <span" +
      " class='fw-bold'>d’exsudat diminue au fur et à mesure de sa cicatrisation</span>.<sup>1</sup>" +
      "<img class='d-block mt-3' src='" + urlImages + "02sec11e_img.png' />",
    annexes_expl11: [
      "<span class='small-text d-block text-start mt-4'>" +
      "Schéma&nbsp;: Journal des plaies et cicatrisation N°9 Septembre 1997 SFFPC." +
      "</span>"
    ],
    title_expl12: "Cicatrisation&nbsp;: l’humidité",
    text_expl12: "Les travaux de Winter dans les années 1960 ont permis de démontrer une <span" +
      " class='fw-bold'>meilleure cicatrisation en MILIEU HUMIDE.</span><sup>1</sup><br/><br/>La plupart des" +
      " pansements sont destinés à <span class='fw-bold'>favoriser la cicatrisation en milieu" +
      " humide.<sup>2</sup></span>",
    list_buttons_expl12: [
      {
        group: "",
        title: "Les travaux de Winter&nbsp;: késaco&nbsp;?",
        content: [
          {
            title: "Les travaux de <span class='fw-bold'>Winter en synthèse</span>&nbsp;: <sup>1</sup>",
            image: urlImages + "02sec12e_modal_img.png",
            small_texts: {
              1: SmallTexts.EffectAirDrying
            }
          }
        ],

      }
    ],
    title_expl13: "Nettoyage et soin des plaies",
    text_expl13: "<span class='small'>Connaissez-vous les bonnes pratiques de nettoyage des plaies&nbsp;?" +
      "<ul class='my-4'>" +
      "  <li class='mb-2'>Il s’effectue <span class='fw-bold'>à l’eau et au savon doux</span><sup>1</sup></li>" +
      "  <li class='mb-2'>Il en est de même après une intervention chirurgicale<sup>1</sup></li>" +
      "  <li class='mb-2'>L’utilisation en routine des antiseptiques et des antibiotiques locaux n’est recommandée par aucune" +
      " étude scientifique<sup>1</sup></li>" +
      "  <li class='mb-2'>Utilisés à tort, les antibiotiques peuvent entraîner une <span" +
      " class='fw-bold'>antibiorésistance</span>.</li>" +
      "  <li>Les antiseptiques permettent de désinfecter la peau saine <span class='fw-bold'>AVANT</span> un soin" +
      " qui franchit la barrière cutanée<sup>2</sup></li>" +
      "</ul></span>" +
      "<h4 class='color-green fw-bold mt-5 mb-0'>Quelle que soit la plaie, son traitement est D’ABORD CELUI DE SON" +
      " ÉTIOLOGIE<sup>1</sup></h4>"
  },
  Responses: {
    title_correct_q01: "Bravo&nbsp;!",
    title_not_correct_q01: "Ce n’est pas la bonne reponse&nbsp;!",
    text_correct_q01: "Merci de votre aide, vous avez retrouvé la plaie chronique&nbsp;!",
    text_not_correct_q01: "Vous pouvez revenir en arrière pour essayer à nouveau.",
    title_correct_q02: "C’est exactement ça&nbsp;!",
    text_q02: "Si vous voulez en savoir plus sur les différentes phases de la cicatrisation, cliquez sur" +
      " chaque image.<sup>1,2</sup>",
    annexes_q02: [
      "<span class='d-block text-start'>La durée de l’ensemble de ces phases dépend, entre" +
      " autres, des comorbidités, de la prise en charge et du protocole appliqué.</span>"
    ],
    title_not_correct_q02: "Vous y êtes presque&nbsp;!",
    texts_explication_q02: [
      {
        title: "La détersion",
        image: urlImages + "02secDET_q_resp.png",
        content_popup: [
          {
            text: "La <span class='fw-bold'>DÉTERSION</span> est un mécanisme cellulaire qui élimine les débris (tissus morts, fibrine, etc.) qui encombrent le fond de la plaie et empêchent la cicatrisation."
          }
        ]
      },
      {
        title: "La granulation",
        image: urlImages + "02secGRA_q_resp.png",
        content_popup: [
          {
            text: "Lors de la période de <span class='fw-bold'>BOURGEONNEMENT</span>, la plaie devient plus" +
              " granuleuse et de couleur rouge. Vient ensuite l’épithélialisation, correspondant au recouvrement progressif de la plaie par les cellules épithéliales de façon centripète."
          }
        ]
      },
      {
        title: "L’épidermisation",
        image: urlImages + "02secEPI_q_resp.png",
        content_popup: [
          {
            text: "<span class='fw-bold'>L’ÉPIDERMISATION</span>, aussi appelée « remodelage cicatriciel », correspond à d’imperceptibles contractions de la peau qui amènent la plaie à se refermer et à s’assécher pour laisser place à une peau rosée."
          }
        ]
      }
    ],
    title_correct_q03: "Échec et mat&nbsp;!",
    title_not_correct_q03: "Votre stratégie est à revoir&nbsp;!",
    text_q03: "L’augmentation du volume de l’exsudat lors du processus de cicatrisation doit faire envisager un" +
      " problème de <span class='fw-bold'>surinfection</span>.<sup>1</sup><br/>En cas de doute, n’hésitez pas à" +
      " contacter le médecin du patient."
  },
  EndTexts: {
    title_end01: "Félicitations, les principes fondamentaux de la cicatrisation n’ont plus de secret pour" +
      " vous&nbsp;!",
    text_end01: "Ces connaissances vous seront très utiles pour choisir la bonne stratégie et reconnaître les pansements techniques appropriés à la plaie et au patient.",
    annexes_end01: [
      "Avant de continuer la partie, téléchargez <a class='doc-download' href='" + Documents.Document1 + "' data-document-id='" + DocumentsIds.Document1 + "' target='_blank'>une fiche récapitulative</a> de ce module.",
    ],
  }
}


